export default "__VITE_ASSET__Bt6x$ZRB__"